import React from 'react'

// Components
import UIDashboardQuickSight from '../../UI/Dashboard/QuickSight'

const DashboardCummins = () => {
  return <UIDashboardQuickSight id="c93db1a8-ef0a-4ccc-addd-c18c07dedda2" />
}

export default DashboardCummins
